const paths = {
  home: { path: "" },
  prizes: { path: "prizes" },
  howToPlay: { path: "how-to-play" },
  gameRules: { path: "game-rules" },
  faqs: { path: "faqs" },
  terms: { path: "terms" },
  statistics: { path: "statistics" },
  statisticsDetails: {
    path: "details",
    parent: "statistics",
  },
  createTeam: { path: "create-team" },
  myTeam: { path: "my-team", isAuth: true },
  oppTeam: { path: "opp-team", isAuth: true },
  manageTeam: {
    path: ":teamId",
    parent: "my-team",
  },
  completedRacesDetailed: {
    path: "completed-races/:gameDayId",
    parent: "my-team",
  },
  raceWeekTeam: {
    path: ":gameDayId/:phaseId/:teamNo",
    parent: "my-team",
  },
  userRaceWeekTeam: {
    path: ":userId/:gameDayId/:phaseId/:teamNo",
    parent: "my-team",
  },
  detailedMyTeam: {
    path: "detail/:gameDayId/:phaseId/:teamNo",
    parent: "my-team",
  },
  detailedOppTeam: {
    path: "detail-opp/:gameDayId/:phaseId/:teamNo",
    parent: "opp-team",
  },
  leagues: { path: "leagues", isAuth: true },
  leagueSelectTeam: {
    isAuth: true,
    path: "select-team",
    parent: "leagues",
  },
  joinLeague: {
    isAuth: true,
    path: "join/",
    parent: "leagues",
  },
  selectedJoinLeague: {
    path: "join/:code",
    parent: "leagues",
  },
  createLeague: { path: "create-league", parent: "leagues", isAuth: true },
  congratulations: { path: "congratulations", parent: "leagues", isAuth: true },
  leagueMembers: { path: "leaderboard/:type/:leagueId", parent: "leagues" },
  leagueShare: { path: "leaderboard/:type/:leagueId/share", parent: "leagues" },
  leagueMarketingPage: { path: ":type/:leagueName", parent: "leagues" },
  leaguesManage: {
    path: "manage/:type/:leagueId",
    parent: "leagues",
  },
  webview: { path: "webview" },
  performanceChart: { path: "performance-chart" },
  miniLeagueRedirect: { path: "mini-league-redirect" },
  whatsNew: { path: "whats-new" },
};
export default paths;
